import React, { useState } from 'react';
import { AptunoButton, Icon, SIZES, useResponsive, VARIANTS } from '@aptuno/aptuno-ui';
import { Head } from '@shared/Seo/components/Head';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import {
  AuxiliarySide,
  BoxButton,
  BoxImage,
  BoxImageMain,
  ButtonLeaseCalculator,
  Container,
  Description,
  Item,
  MainTitle,
  SectionPrimary,
  SectionSecondary,
  Title,
} from './LandingLeaseCalculator.styled';
import { DataSectionSecondary } from './data-content';
import { useRouter } from 'next/router';
import { ContainerIsTenant, LabelInformative, SectionIsTenant } from '../LandingLandlord/LandingLandlord.styled';
import BubbleDecoration from './BubbleDecoration/BubbleDecoration';
import { useAnalyticsTracker } from '@services/analytics';
import { CalculatorCTAClicked } from './events/calculator-cta-clicked.event';
import { TenantCTAClicked } from './events/tenant-cta-clicked.event';

const LandingLeaseCalculator = () => {
  const { isMobile, isDesktop, isMediumSize } = useResponsive();
  const seoT = useTranslations('Seo');
  const eventTracker = useAnalyticsTracker();
  const router = useRouter();
  const [isTenantButtonOpen, setTenantButtonOpen] = useState<boolean>(true);

  const CTASegmentLeaseCalculator = (labelButton: string) => {
    eventTracker.trackEvent(new CalculatorCTAClicked(labelButton));

    router.push(`${seoT('pageview.LandingLeaseCalculator.route')}/calcular`);
  };

  const CTASegmentTenant = (labelButton: string) => {
    eventTracker.trackEvent(new TenantCTAClicked(labelButton));
    window.location.href = '/inmuebles-arriendo';
  };

  return (
    <Container isMobile={isMobile} isDesktop={isDesktop} isMediumSize={isMediumSize}>
      <Head
        title={seoT('pageview.LandingLeaseCalculator.title')}
        description={seoT('pageview.LandingLeaseCalculator.description')}
        image={seoT('homeSeoImage')}
        url={seoT('pageview.LandingLeaseCalculator.canonical')}
      />

      <ContainerIsTenant isOpenTenantButton={isTenantButtonOpen}>
        <SectionIsTenant>
          <LabelInformative color={'#000'}>
            Si estás buscando tu próximo hogar,{' '}
            <a onClick={() => CTASegmentTenant('Si estás buscando tu próximo hogar')}>haz click aquí</a>
          </LabelInformative>
          <Icon
            icon="closeAlt"
            color={'#000'}
            onClick={() => setTenantButtonOpen(() => !isTenantButtonOpen)}
            width={'10px'}
            height={'10px'}
          ></Icon>
        </SectionIsTenant>
      </ContainerIsTenant>

      <BubbleDecoration />
      {isDesktop && <AuxiliarySide className="right_aux_grid_1" />}
      {isDesktop && <AuxiliarySide className="left_aux_grid_1" />}

      <SectionPrimary isDesktop={isDesktop} isMediumSize={isMediumSize} className="section_content">
        <MainTitle isDesktop={isDesktop} isMediumSize={isMediumSize} className="grid_1">
          Calcula el precio perfecto para arrendar tu inmueble
        </MainTitle>

        <BoxImageMain isDesktop={isDesktop} isMediumSize={isMediumSize} className="grid_2">
          <Image
            loader={() => 'images/landing-pages/landing-calculator/calculator01.svg'}
            src="images/landing-pages/landing-calculator/calculator01.svg"
            width={isMobile ? 279 : 589}
            height={isMobile ? 188 : 501}
            alt="Publicar inmueble, casa o apartamento para arrendar con Aptuno"
            title="Publicar Inmueble en Aptuno"
          />
        </BoxImageMain>

        <BoxButton isDesktop={isDesktop} isMediumSize={isMediumSize} className="grid_3">
          <Item isMediumSize={isMediumSize}>
            <AptunoButton
              onClick={() => CTASegmentLeaseCalculator('Calcular precio de mi inmueble')}
              appearance={VARIANTS.PRIMARY}
              size={SIZES.MEDIUM}
            >
              Calcular precio de mi inmueble
              <Icon icon="arrowrightalt" />
            </AptunoButton>
          </Item>
        </BoxButton>
      </SectionPrimary>
      {isDesktop && <AuxiliarySide className="left_aux_grid_10" backgroundColor="#FFF9EB" height="394px" />}
      {isDesktop && <AuxiliarySide className="right_aux_grid_10" backgroundColor="#FFF9EB" height="394px" />}
      {DataSectionSecondary.map((el, index) => {
        return (
          <SectionSecondary
            key={index}
            isDesktop={isDesktop}
            isMediumSize={isMediumSize}
            className="section_content"
            background={el.background}
          >
            <Title isDesktop={isDesktop} className="grid_1">
              {el.title}
            </Title>
            <Description isDesktop={isDesktop} className="grid_2">
              {el.descriptionPrimary}
            </Description>

            <ButtonLeaseCalculator
              onClick={() => CTASegmentLeaseCalculator(el?.messageButton)}
              borderColor={el.borderColor}
              iconColor={el.iconColor}
              isDesktop={isDesktop}
              className="grid_3"
              backgroundButton={el.background ? '#FFF9EB' : ''}
            >
              {el.messageButton}
              <Icon icon="arrowrightalt" />
            </ButtonLeaseCalculator>

            <BoxImage isMediumSize={isMediumSize} className="grid_4">
              {el?.imageUrl && (
                <Image
                  src={el?.imageUrl}
                  width={isMobile ? el.widthImageMobile : el.widthImageDesktop}
                  height={isMobile ? el.heightImageMobile : el.heightImageDesktop}
                  alt={el?.altImage}
                  title={'Publicar Inmueble | Aptuno'}
                />
              )}
            </BoxImage>
          </SectionSecondary>
        );
      })}
    </Container>
  );
};

export default LandingLeaseCalculator;
